import { FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Form, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { GeneralLedgerCategories, VatCategories } from '../../../library/constants';
import { convertDataTypes } from '../../../library/helpers/index.js';
import ExecutiveEntitySelect from '../../inputs/ExecutiveEntitySelect.js';

const GeneralLedgerFilterForm = ({ children, data, ...otherProps }) => {
    const [form] = Form.useForm();

    const formattedValues = useMemo(() => {
        return convertDataTypes(data, {
            entity_id: v => (parseInt(v) || undefined),
            category: v => (parseInt(v) || undefined),
            vat_category: v => (parseInt(v) || undefined),
            priority: v => (v === 'true' || v === true || v === '1' || v === 1 ? 'true' : v === 'false' || v === false || v === '0' || v === 0 ? 'false' : undefined),
        }) || {};
    }, [data]);

    useEffect(() => {
        form.setFieldsValue({
            entity_id: undefined,
            category: undefined,
            vat_category: undefined,
            priority: undefined,
            ...formattedValues,
        });
    }, [formattedValues, form]);

    const clearForm = () => {
        try {
            form.setFieldsValue({
                entity_id: null,
                category: null,
                vat_category: null,
                priority: null,
            });
            form.submit();
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <Form
            form={form}
            initialValues={formattedValues}
            layout="vertical"
            {...otherProps}
        >
            <Form.Item name="entity_id" label="Entity">
                <ExecutiveEntitySelect allowClear getPopupContainer={triggerNode => triggerNode.parentElement} />
            </Form.Item>

            <Form.Item name="category" label="Category">
                <Select
                    allowClear
                    placeholder="Select Category"
                    options={Object.entries(GeneralLedgerCategories).map(([value, label]) => ({
                        value: Number(value),
                        label,
                    }))}
                    getPopupContainer={triggerNode => triggerNode.parentElement}
                />
            </Form.Item>

            <Form.Item name="vat_category" label="VAT Category">
                <Select
                    allowClear
                    placeholder="Select VAT Category"
                    options={Object.entries(VatCategories).map(([value, label]) => ({
                        value: Number(value),
                        label,
                    }))}
                    getPopupContainer={triggerNode => triggerNode.parentElement}
                />
            </Form.Item>

            <Form.Item name="priority" label="Priority">
                <Select
                    allowClear
                    placeholder="Select Priority"
                    options={[
                        { label: 'Priority Only', value: 'true' },
                        { label: 'Non-Priority', value: 'false' },
                    ]}
                    getPopupContainer={triggerNode => triggerNode.parentElement}
                />
            </Form.Item>

            {children}

            <div className="actions filter-actions">
                <Button htmlType="submit" type="primary" icon={<FilterOutlined />}>Apply</Button>
                <Button onClick={clearForm} icon={<ReloadOutlined />}>Reset</Button>
            </div>
        </Form>
    );
};

GeneralLedgerFilterForm.propTypes = {
    children: PropTypes.node,
    data: PropTypes.object,
    onFinish: PropTypes.func,
};

export default GeneralLedgerFilterForm;
